/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface SurveysChangeProposedSupervisorBody { 
    /**
     * 
     */
    type: SurveysChangeProposedSupervisorBody.TypeEnum;
    /**
     * 
     */
    supervisorId: number;
    /**
     * 
     */
    periodId: number;
}
export namespace SurveysChangeProposedSupervisorBody {
    export type TypeEnum = 'ogs';
    export const TypeEnum = {
        Ogs: 'ogs' as TypeEnum
    };
}


